import * as SecureStore from "@towersystems/roam-common-native";

import { LINKLY_STORAGE_KEY } from "./constants";

export const retrieveLinklyDataAsync = async (key: string) => {
  let data = await SecureStore.getItemAsync(toKey(key));
  if (data) {
    return data;
  } else return null;
};

export const storeLinklyDataAsync = async (
  key: string,
  data: string | null | undefined
) => {
  await SecureStore.storeItemAsync(toKey(key), data ?? "");
};

function toKey(key: string) {
  return `${LINKLY_STORAGE_KEY}_${key}`;
}
